class SchulbuchBundle extends HTMLElement {
    constructor() {
        super();
        this.submitButton = this.querySelector("button[type='submit']");
        this.defaultValueSchulart = this.querySelector("select[name='schulart']").value;
        this.defaultValueSchreibhand = this.querySelector("input[name='schreibhand']:checked").value;
        this.events = ["change"];
        this.addListener();
    }

    get currentValueSchulart() {
        return this.querySelector("select[name='schulart']").value;
    }

    get currentValueSchreibhand() {
        return this.querySelector("input[name='schreibhand']:checked").value;
    }

    disconnectedCallback() {
        this.removeListener();
    }

    addListener() {
        for (const event of this.events) {
            this.addEventListener(event, this);
        }
    }

    removeListener() {
        for (const event of this.events) {
            this.removeEventListener(event, this);
        }
    }

    // https://gomakethings.com/the-handleevent-method-is-the-absolute-best-way-to-handle-events-in-web-components/
    handleEvent(event) {
        this[`handle${event.type}`](event);
    }

    handlechange(event) {
        if (this.currentValueSchulart !== this.defaultValueSchulart || this.currentValueSchreibhand !== this.defaultValueSchreibhand) {
            this.submitButton.removeAttribute("hidden");
        } else {
            this.submitButton.setAttribute("hidden", "");
        }
    }
}

if (!customElements.get("schulbuch-bundle")) {
    customElements.define("schulbuch-bundle", SchulbuchBundle);
}